import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosService from '../../../utility/axiosService/axiosService';
import { API_ENDPOINT } from '../../../utility';
import { toast } from 'react-toastify';

export const getBonusMerchantList = createAsyncThunk('users/getBonusMerchantList', async (data) => {
    if (data == 'all') {
        return await axiosService
            .get(`${API_ENDPOINT}/admin/merchant-bonus`, {
                params: {
                    limit: 100
                }
            })
            .then((res) => {
                return res.data;
            });
    } else {
        return await axiosService
            .get(`${API_ENDPOINT}/admin/merchant-bonus`, {
                params: data
                    ? {
                          page: data.page,
                      }
                    : {
                          page: 1,
                      }
            })
            .then((res) => {
                return res.data;
            });
    }
});

export const getProductLineList = createAsyncThunk('users/getProductLineList', async (data) => {
    if (data == 'all') {
        return await axiosService
            .get(`${API_ENDPOINT}/admin/product-line`, {
                params: {
                    limit: 100,
                    status:1,
                }
            })
            .then((res) => {
                return res.data;
            });
    } else {
        return await axiosService
            .get(`${API_ENDPOINT}/admin/product-line`, {
                params: data
                    ? {
                          page: data.page,
                          status:1,
                          limit: 100
                      }
                    : {
                          page: 1,
                          status:1,
                          limit: 100,
                      }
            })
            .then((res) => {
                return res.data;
            });
    }
});

export const getMerchantList = createAsyncThunk('users/getMerchantList', async (data) => {
    if (data == 'all') {
        return await axiosService
            .get(`${API_ENDPOINT}/admin/merchant`, {
                params: {
                    limit: 100
                }
            })
            .then((res) => {
                return res.data;
            });
    } else {
        return await axiosService
            .get(`${API_ENDPOINT}/admin/merchant`, {
                params: data
                    ? {
                          page: data.page
                      }
                    : {
                          page: 1,
                          limit: 100,
                      }
            })
            .then((res) => {
                return res.data;
            });
    }
});



export const createNewBonusMerchant = createAsyncThunk('users/createNewBonusMerchant', async (data) => {
    return await axiosService.post(`${API_ENDPOINT}/admin/merchant-bonus`, data).then((res) => {
        return res.data;
    });
});

export const updateBonusMerchant = createAsyncThunk(
    'users/updateBonusMerchant',
    async (data) => {
        const updateData = {
            "sales": data.sales,
            "bonus_rate": data.bonus_rate,
        }
        return await axiosService.put(`${API_ENDPOINT}/admin/merchant-bonus/${data.id}`, updateData).then((res) => {
            return res;
        }).catch((err) => console.log(err));
    }
)

export const FillterBonusMerchant= createAsyncThunk('users/filterBonusMerchant', async (dataFilter) => {
    return await axiosService
        .get(`${API_ENDPOINT}/admin/merchant-bonus`, {
            params: {
                limit: 100
            }
        })
        .then((res) => {
            const dataFilterBonusMerchant = res.data.data.result.filter(
                (item) =>
                    (item.product_line_name.toLowerCase() != null && item.product_line_name.toLowerCase().includes(dataFilter.toLowerCase())) || 
                    item.merchant_name.toLowerCase() != null && item.merchant_name.toLowerCase().includes(dataFilter.toLowerCase()) || item.sales.toString().toLowerCase().includes(dataFilter.toLowerCase()) || item.bonus_rate.toString().toLowerCase().includes(dataFilter.toLowerCase())
            );
            return dataFilterBonusMerchant;
        });
});

export const DeleteBonusMerchant = createAsyncThunk('users/DeleteBonusMerchant', async (data) => {
    return await axiosService
        .delete(`${API_ENDPOINT}/admin/merchant-bonus/${data.id}`)
        .then((res) => {
            return res.data;
        });
});

const bonusMerchantSlice = createSlice({
    name: 'bonusmerchant',
    initialState: {
        loading: false,
        modal: false,
        data: [],
        total_page: 0,
        dataBonusMerchant: [],
        dataProductLine:[],
        dataMerchant:[],
        dataDetails: null,
        error: null,
        // keyword: "",
        // page: 1,
        dataFilter: {
            keyword: '',
            page: 1
        }
    },
    reducers: {
        getModal: (state, { payload }) => {
            state.modal = true;
            state.dataDetails = payload;
        },
        removeModal: (state) => {
            state.dataDetails = null;
            state.modal = false;
        },
        searchTextFieldSlice: (state, { payload }) => {
            state.keyword = payload.data;
        },
        paginationHandleSlice: (state, { payload }) => {
            state.page = payload.data;
        },
        filterData: (state, { payload }) => {
            state.dataFilter.keyword = payload.page
                ? payload.keyword || state.dataFilter.keyword
                : payload.keyword;
            state.dataFilter.page = payload.page || state.dataFilter.page;
        }
    },
    extraReducers: {
        [getBonusMerchantList.pending]: (state) => {
            state.loading = true;
        },
        [getBonusMerchantList.fulfilled]: (state, { payload }) => {
            state.dataBonusMerchant = payload.data.result;
            state.total_page = payload.data.total_page;
            state.loading = false;
        },
        [getProductLineList.pending]: (state) => {
            state.loading = true;
        },
        [getProductLineList.fulfilled]: (state, { payload }) => {
            state.dataProductLine = payload.data.result;
            state.total_page = payload.data.total_page;
            state.loading = false;
        },
        [getMerchantList.pending]: (state) => {
            state.loading = true;
        },
        [getMerchantList.fulfilled]: (state, { payload }) => {
            state.dataMerchant = payload.data.data;
            state.total_page = payload.data.total_page;
            state.loading = false;
        },
        [FillterBonusMerchant.pending]: (state) => {
            state.loading = true;
        },
        [FillterBonusMerchant.fulfilled]: (state, { payload }) => {
            state.dataBonusMerchant = payload;
            state.total_page = 1;
            state.loading = false;
        },
        [createNewBonusMerchant.fulfilled]: (state, { payload }) => {
            if (payload.code == 0) {
                // state.dataOrganizations.unshift(payload.data);
                toast.success('Thêm mới thành công !');
            }
            if (payload.code == 2) {
                toast.error('Đã tồn tại vui lòng tạo lại');
            }
        },
        [createNewBonusMerchant.rejected]: (state, action) => {
            state.error = action.payload;
            toast.error('Đã tồn tại vui lòng tạo lại');
        },
        [updateBonusMerchant.fulfilled]: (state, { payload }) => {
            if (payload.data.code === 0) {
                toast.success('Cập nhật dữ liệu thành công !');
            } else {
                toast.error(`Cập nhật dữ liệu thất bại: ${payload.data.mess}`);
            }
            // const index = state.dataOrganizations.findIndex(_item => _item.id === payload.data.data.id);
            // state.dataOrganizations[index] = payload.data.data;
        },
        [updateBonusMerchant.rejected]: (state, action) => {
            state.error = action.payload;
        },
        [DeleteBonusMerchant.fulfilled]: (state, { payload }) => {
            if (payload.code == 0) {
                // state.dataOrganizations.unshift(payload.data);
                toast.success('Xóa thành công !');
            }
        },
        [DeleteBonusMerchant.rejected]: (state, action) => {
            state.error = action.payload;
            toast.error('Xóa thất bại');
        }
    }
});

export const { getModal, removeModal, filterData, searchTextFieldSlice, paginationHandleSlice } =
    bonusMerchantSlice.actions;

export default bonusMerchantSlice.reducer;
